import type {SidebarExtension} from "./types";

import {aiAssistantExtension} from "@project/extensions/ai-assistant/ai-assistant.extension";

export const sidebarExtensionsById: Record<string, SidebarExtension> = {
  [aiAssistantExtension.id]: aiAssistantExtension,
};

export const sidebarExtensionList = Object.values(sidebarExtensionsById);
